import { render, staticRenderFns } from "./Act__header.vue?vue&type=template&id=bbce9674&scoped=true&"
import script from "./Act__header.vue?vue&type=script&lang=js&"
export * from "./Act__header.vue?vue&type=script&lang=js&"
import style0 from "@/style/wrapper.css?vue&type=style&index=0&id=bbce9674&scoped=true&lang=css&"
import style1 from "./Act__header.vue?vue&type=style&index=1&id=bbce9674&scoped=true&lang=css&"
import style2 from "./Act__header.vue?vue&type=style&index=2&id=bbce9674&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbce9674",
  null
  
)

export default component.exports